import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Navigate, useLoaderData } from 'react-router';
import { paths } from '../../../common/constants/pathVariables.js';
import { NewSupportCaseAuthenticated } from '../../../components/NewSupportCaseAuthenticated/NewSupportCaseAuthenticated.js';
import { SystemError } from '../../../components/SystemError/SystemError.js';
import { setCaseSentStatus } from '../../../selfservice/actions/index.js';
import type { SupportCaseFormLoaderData } from '../../../common/loaders';
import type { State } from '../../../selfservice/common/store.js';

interface SupportCaseSentRedirectProps {
  supportCaseSent?: boolean;
}

const SupportCaseSentRedirect = ({ supportCaseSent }: SupportCaseSentRedirectProps) => {
  const dispatch = useDispatch();

  useEffect(() => {
    if (supportCaseSent) {
      dispatch(setCaseSentStatus(false));
    }
  });

  return <Navigate to={paths.MESSAGE_CENTER_SUPPORT_CASES} />;
};

export const NewSupportCaseAuthenticatedPath = () => {
  const supportCaseSent = useSelector((state: State) => state.selfservice?.supportCases?.supportCaseSent);
  const supportCaseFailed = useSelector((state: State) => state.selfservice?.supportCases?.supportCaseFailed);
  const errors = useSelector((state: State) => state.selfservice?.supportCases?.errors);
  const { billChannels, companyInfo } = useLoaderData() as SupportCaseFormLoaderData;

  if (supportCaseFailed) {
    return <SystemError errors={errors} homePath={paths.SELF_SERVICE_HOME} />;
  } else if (supportCaseSent) {
    return <SupportCaseSentRedirect supportCaseSent={supportCaseSent} />;
  } else {
    return <NewSupportCaseAuthenticated billChannels={billChannels} companyInfo={companyInfo} />;
  }
};
